export default "__VITE_ASSET__c644c2cd__"